import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mt-6 pb-2 text-left overflow-x-auto" }
const _hoisted_9 = { class: "mt-5 sm:mt-6" }
const _hoisted_10 = { class: "text-center text-red-500" }

import { computed, inject, ref, shallowRef, watch, onMounted } from "vue";
import { Dialog, DialogTitle, DialogOverlay, TransitionRoot, TransitionChild } from "@headlessui/vue";
import DataTable from "../tools/DataTable.vue";
import Pagination from "../tools/Pagination.vue";
import dayjs from "dayjs";
import { formatNumber, translate } from "@/utils/tools";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import GameRoundResettleDialog from "./GameRoundResettleDialog.vue";
import { useRouter } from "vue-router";
import { AxiosInstance } from "axios";
import GameResultDialog from "./GameResultDialog.vue";
import PopOver from "@/components/tools/PopOver.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GameRoundDetailDialog',
  props: { resettleData: Object, show: Boolean, moduleCode: String, hasGameResult: Boolean },
  emits: ["submit", "pageChange", "update:show", "update:form", "cancelBet", "resettle"],
  setup(__props, { emit }) {

const props = __props

const axios = inject("$axios") as AxiosInstance;
const router = useRouter(); //////////////////////////////////////////////////

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const popOver = shallowRef(PopOver);
const resultErrorMessage = ref<string>("");
const showGameResultDialog = ref<boolean>(false);
const resettleDialog = ref<boolean>(false);
const showGameResultErrorDialog = ref<boolean>(false);
const resettlePayloadData = ref<any>({});
const results = ref([]);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  isEmitOnClick: true,
  sort: [["created_at", "DESC"]],
});
const isShowGameResult = ref(false);

const viewResult = async (data: any) => {
  const {
    moduleCode: providerCode,
    refCode,
    refCode2,
    refCode3,
    operatorId,
    userdata7: alias,
    username,
    refCode5: gameCode,
    createdAt,
  } = data;

  const { data: gameResult } = await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/game/internal/view-result`, {
      operatorId,
      providerCode,
      refCode,
      refCode2,
      refCode3,
      gameCode: gameCode,
      alias: alias || username,
      createdAt,
    })
    .catch(() => {
      resultErrorMessage.value = "เกมนี้ไม่รองรับการดูผลผ่านเว็บ กรุณาติดต่อทีม support";
      showGameResultErrorDialog.value = true;
    });
  if (gameResult.result === null) {
    resultErrorMessage.value = "ไม่พบข้อมูลเกม กรุณาติดต่อทีม Support";
    showGameResultErrorDialog.value = true;
  }
  if (gameResult.type.toLowerCase() === "url" && gameResult.result) {
    window.open(gameResult.result.url);
  }
  if (gameResult.type.toLowerCase() === "json" && gameResult.result) {
    results.value = gameResult.result;
    showGameResultDialog.value = true;
  }
};

const filterModal = (flag?: number) => {
  resettleDialog.value = false;
  if (flag) {
    emit("resettle", resettlePayloadData.value);
  }
};

const onCancelBet = (data: any) => {
  const payload = {
    requestId: `FORCECANCEL:${data.refCode}`,
    amount: Number(data.amount),
    operatorId: data.operatorId,
    providerCode: data.moduleCode,
    refCode: data.refCode,
    refCode2: data.refCode2,
    userId: data.userId,
    alias: data.userdata7 || null,
    moduleCode: data.moduleCode,
  };
  emit("cancelBet", payload);
};
const onResettleBet = (data: any) => {
  resettleDialog.value = true;
  resettlePayloadData.value = {
    requestId: `FORCESETTLE:${data.refCode}`,
    amount: data.amount || 0,
    operatorId: data.operatorId,
    providerCode: data.moduleCode,
    refCode: data.refCode,
    refCode2: data.refCode2,
    userId: data.userId,
    alias: data.userdata7 || null,
  };
  // emit("resettle", payload)
};

const columns = [
  {
    label: translate("messages.gameRounds.actions"),
    field: "action",
    isSorted: false,
  },
  {
    label: translate("messages.gameRounds.from"),
    field: "moduleCode",
    isSorted: false,
    format: (data: any) => {
      if (data.userdata7) {
        return `${data.moduleCode}  \r\n Alias: ${data.userdata7}  `;
      }
      if (data.username) {
        return `${data.moduleCode}  \r\n Alias: ${data.username}  `;
      } else {
        return `${data.moduleCode}`;
      }
    },
  },
  {
    label: translate("messages.gameRounds.roundId"),
    field: "refCode2",
    isSorted: false,
  },
  {
    label: translate("messages.gameRounds.amount"),
    field: "amount",
    format: (data: any) => formatNumber(data.amount),
    class: (data: any) => {
      if (data.amount > 0) return "text-green-500";
      else return "text-red-500";
    },
  },
  {
    label: translate("messages.gameRounds.validBet"),
    field: "validAmount",
    format: (data: any) => formatNumber(data.validAmount),
    class: (data: any) => {
      if (data.validAmount > 0) return "text-green-500";
      else return "text-red-500";
    },
  },
  {
    label: translate("messages.gameRounds.openBalance"),
    field: "openBalance",
    format: (data: any) => formatNumber(data.openBalance),
    class: (data: any) => {
      if (data.openBalance > 0) return "text-green-500";
      else return "text-red-500";
    },
  },
  {
    label: translate("messages.gameRounds.closeBalance"),
    field: "closeBalance",
    format: (data: any) => formatNumber(data.closeBalance),
    class: (data: any) => {
      if (data.closeBalance > 0) return "text-green-500";
      else return "text-red-500";
    },
  },
  {
    label: translate("messages.gameRounds.createdAt"),
    field: "createdAt",
    format: (data: any) => dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    label: translate("messages.gameRounds.source"),
    field: "refCode5",
  },
  {
    label: "References",
    field: "",
    isHTML: true,
    align: "center",
    format: (data: any) => {
      if (!data.refCode3) return `<p>Txn ID: ${data.refCode}</p>`;
      return `<p>Txn ID: ${data.refCode}</p> <p> Round Group :${data.refCode3}</p>`;
    },
  },
  {
    label: "",
    field: "",
    isSettle: true,
  },
];

watch(
  () => pageConfig.value.page,
  () => {
    emit("pageChange", {
      limit: pageConfig.value.rowsPerPage,
      page: pageConfig.value.page,
    });
  }
);

watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    emit("pageChange", {
      limit: pageConfig.value.rowsPerPage,
      page: pageConfig.value.page,
    });
  }
);
watch(
  () => props.resettleData?.result?.rows,
  (val) => {
    pageConfig.value.dataLength = val.length;
  }
);




const onAuxClick = (e: Event, data: any) => {
  e.preventDefault();
  window.open(`/players/${data[0].userId}`);
  return false;
};

const viewUser = (data: any) => {
  const userId = data[0].userId;
  router.push({ name: "Wallet Info", params: { id: userId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: _unref(showSync),
        static: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            static: "",
            class: "fixed z-10 inset-0 overflow-y-auto",
            onClose: _cache[7] || (_cache[7] = ($event: any) => (showSync.value = false)),
            open: _unref(showSync)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                  ]),
                  _: 1
                }),
                _hoisted_2,
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_unref(DialogTitle), {
                            as: "h3",
                            class: "text-lg leading-6 font-medium text-gray-900 flex flex-row justify-between items-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5,
                              _createElementVNode("div", _hoisted_6, [
                                _createTextVNode(_toDisplayString(_ctx.$t("messages.gameRounds.details")) + " ", 1),
                                _createElementVNode("span", {
                                  class: "text-sm mt-1 text-blue-500 pl-1",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (viewUser(__props.resettleData?.result?.rows))),
                                  onContextmenu: _cache[1] || (_cache[1] = (e) => onAuxClick(e, __props.resettleData?.result?.rows))
                                }, " (" + _toDisplayString(_ctx.$t("messages.gameRounds.viewUser")) + ") ", 33)
                              ]),
                              (!__props.hasGameResult)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                                : _createCommentVNode("", true),
                              (__props.hasGameResult)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "text-sm bg-blue-500 p-1 rounded-md text-white focus:ring",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (viewResult(__props.resettleData?.result?.rows[0])))
                                  }, _toDisplayString(_ctx.$t("messages.gameRounds.viewGameResult")), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(DataTable, {
                              class: "mx-auto",
                              columns: columns,
                              data: __props.resettleData?.result?.rows,
                              onCancel: onCancelBet,
                              onResettle: onResettleBet
                            }, null, 8, ["data"]),
                            _createVNode(Pagination, {
                              config: pageConfig.value,
                              "onUpdate:config": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig).value = $event))
                            }, null, 8, ["config"])
                          ])
                        ]),
                        _createVNode(GameRoundResettleDialog, {
                          show: resettleDialog.value,
                          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((resettleDialog).value = $event)),
                          form: resettlePayloadData.value,
                          "onUpdate:form": _cache[5] || (_cache[5] = ($event: any) => ((resettlePayloadData).value = $event)),
                          onReSettle: filterModal
                        }, null, 8, ["show", "form"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('submit'))),
                          class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                        }, " close ")
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["open"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(GameResultDialog, {
        show: showGameResultDialog.value,
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((showGameResultDialog).value = $event)),
        "data-rows": results.value
      }, null, 8, ["show", "data-rows"])
    ]),
    _createVNode(DialogComponent, {
      title: _ctx.$t('messages.gameRounds.error'),
      isOpen: showGameResultErrorDialog.value,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (showGameResultErrorDialog.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_10, _toDisplayString(resultErrorMessage.value), 1)
      ]),
      _: 1
    }, 8, ["title", "isOpen"])
  ], 64))
}
}

})